import { useContext } from 'react';
import { Navigate } from "react-router-dom"
import { useKeycloak } from "../../auth/useKeycloak";
import { AppConfig, AppConfigType } from '../context/context';

export interface IProps {
  children: JSX.Element;
  requiredRoles: string[];
  requiredFeature?: string;
}

export const AuthRoute = ({ children, requiredRoles, requiredFeature }: IProps) => {
  const { authenticated } = useKeycloak();
  const appContext = useContext(AppConfig);

  if (!appContext) {
    return <Navigate to="/" replace />;
  }

  const { userProfile, availableFeatures } = appContext;

  if (!userProfile) {
    return <Navigate to="/" replace />;
  }

  const { role } = userProfile;
  const userHasRequiredRole = requiredRoles.includes(role);
  const orgHasRequiredFeature = requiredFeature ? availableFeatures.includes(requiredFeature) : true;

  return (
    authenticated && userHasRequiredRole && orgHasRequiredFeature ? children : <Navigate to="/" replace />
  );
};
